import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=66f5923f&scoped=true&"
import script from "./PageHeader.vue?vue&type=script&lang=ts&"
export * from "./PageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=66f5923f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f5923f",
  null
  
)

export default component.exports